import { useCurrentCategory } from './useCurrentCategory/useCurrentCategory';
import { useQueryParam } from './useQueryParam';
import { useCategoryEntities } from './useCategoryEntities';
import { PropertyOption } from '@/api/types/categories.types';
import { useParseQuery } from '@/hooks/useParseQuery/useParseQuery';
import { useCategoryProperties } from '@/hooks/useCategoryProperties';
import { QUERY } from '@/constants/common';

export const usePropertyOptionsTitle = () => {
  const [query] = useQueryParam(`${QUERY.q}[${QUERY.keywords}]`);
  const { categoryProperties, isCategoriesLoading } = useCategoryProperties();
  const { currentCategory } = useCurrentCategory();
  const { h1, name: currentCategoryName } = currentCategory ?? {};
  const { categoryEntities, loading } = useCategoryEntities();
  const {
    propertyOptions: { collection },
  } = useParseQuery();

  const property = categoryProperties?.find(
    item => item.legacyResourceId === String(collection?.[0]?.legacyId)
  );

  const firstPropertyOption = property?.options.find(
    item => item.legacyResourceId === collection?.[0]?.value
  );

  const secondPropertyOption = categoryEntities.find(item => {
    const option = item as PropertyOption;

    return option.legacyResourceId === String(collection?.[1]?.value);
  });

  const formattedTitle = [
    h1 || currentCategoryName,
    firstPropertyOption?.name,
    secondPropertyOption?.name,
    query,
  ]
    .filter(Boolean)
    .join(' - ');

  return loading || isCategoriesLoading || !currentCategory?.name
    ? ''
    : formattedTitle;
};
